/**
 * Read the referral code for signup attribution (points phase 3).
 *
 * Prefer the live ?ref= URL param; fall back to the code persisted in
 * localStorage when the visitor first landed on the link. The fallback matters
 * for Google sign-in: the account-picker popup can drop the URL query, but the
 * saved code survives it.
 */
export function readReferralCode(): string | undefined {
   const fromUrl = new URLSearchParams(window.location.search).get('ref');
   if (fromUrl) return fromUrl;
   try {
      return localStorage.getItem('smartfi_ref') || undefined;
   } catch {
      return undefined;
   }
}
